import { getPropertyValue as getValue, getDatePropertyValue } from './transformValueUtils';
export const getCartHighlightFieldValues = ({
  properties
}) => ({
  createdDate: getDatePropertyValue(properties, 'hs_external_created_date'),
  email: getValue(properties, 'email'),
  phone: getValue(properties, 'phone'),
  status: getValue(properties, 'hs_external_status')
});